module.exports = __webpack_public_path__ + "img/audio-wave.3cab9fd0.svg";